import React, { memo, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { skillsData } from '../../data/skills';

const Skills: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isPt = i18n.language.startsWith('pt');
  const [activeCategory, setActiveCategory] = useState(skillsData[0].title);

  const selectedCategory = useMemo(
    () => skillsData.find((category) => category.title === activeCategory) ?? skillsData[0],
    [activeCategory],
  );

  return (
    <section id="skills" className="game-section">
      <div className="game-section__inner">
        <header className="game-section__header">
          <div>
            <span className="game-section__kicker">02 // {isPt ? 'TECNOLOGIAS' : 'TECHNOLOGIES'}</span>
            <h2>{isPt ? 'Tecnologias e competências.' : 'Technologies and skills.'}</h2>
          </div>
          <p>
            {isPt
              ? 'Explore minha stack por área. Cada tecnologia faz parte da construção de produtos, plataformas e sistemas distribuídos.'
              : 'Explore my stack by area. Each technology supports the development of products, platforms, and distributed systems.'}
          </p>
        </header>

        <div className="game-console">
          <aside className="game-console__sidebar" aria-label={isPt ? 'Categorias de habilidades' : 'Skill categories'}>
            <span className="game-console__sidebar-label">{isPt ? 'CATEGORIAS' : 'CATEGORIES'}</span>
            {skillsData.map((category, index) => (
              <button
                type="button"
                key={category.title}
                className={`game-console__tab ${category.title === activeCategory ? 'is-active' : ''}`}
                onClick={() => setActiveCategory(category.title)}
                aria-pressed={category.title === activeCategory}
              >
                <span className="game-console__tab-index">{String(index + 1).padStart(2, '0')}</span>
                <strong>{t(`skills.categories.${category.title}`)}</strong>
                <small>{category.skills.length}</small>
              </button>
            ))}
          </aside>

          <div className="game-console__main">
            <div className="game-console__main-header">
              <div>
                <span className="game-card__eyebrow">{isPt ? 'CATEGORIA SELECIONADA' : 'SELECTED CATEGORY'}</span>
                <h3>{t(`skills.categories.${selectedCategory.title}`)}</h3>
              </div>
              <span className="game-console__badge">
                {selectedCategory.skills.length} {isPt ? 'TECNOLOGIAS' : 'TECHNOLOGIES'}
              </span>
            </div>

            <div className="game-skill-grid">
              {selectedCategory.skills.map((skill) => (
                <article
                  className="game-skill-node"
                  key={skill.name}
                  style={{ '--skill-color': skill.color } as React.CSSProperties}
                >
                  <img src={skill.icon} alt="" loading="lazy" />
                  <strong>{skill.name}</strong>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(Skills);
